export const CONFIRM_EMAIL_REQUEST_START = 'CONFIRM_EMAIL_REQUEST_START';
export const CONFIRM_EMAIL_REQUEST_SUCCESS = 'CONFIRM_EMAIL_REQUEST_SUCCESS';
export const CONFIRM_EMAIL_REQUEST_FAILURE = 'CONFIRM_EMAIL_REQUEST_FAILURE';

export const RESEND_CODE_REQUEST_START = 'RESEND_CODE_REQUEST_START';
export const RESEND_CODE_REQUEST_SUCCESS = 'RESEND_CODE_REQUEST_SUCCESS';
export const RESEND_CODE_REQUEST_FAILURE = 'RESEND_CODE_REQUEST_FAILURE';
